<template>
  <v-container>

          <v-row class="mb-5 mr-1 ml-1" no-gutters>
                <v-col 
                v-if="otros.pagoEfectivo"
                class="pa-2"
                  cols="6"
                  xs="6"
                  sm="4"
                  md="4"
                >
                  <v-card 
                    class="font-italic text-center"
                    @click="activa('overlay1')"
                    max-height="200"
                    max-width="130"
                  >
                          <v-img
                            src="/cash.webp"
                            aspect-ratio="1"
                            max-height="200"
                            max-width="130"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                         <strong class="text-center">Efectivo</strong>
                      <v-overlay
                            :absolute="absolute"
                            :value="overlay1"
                          >
                      </v-overlay>
                  </v-card>
                </v-col>

                <v-col 
                v-if="otros.pagoenTienda"
                class="pa-2"
                  cols="6"
                  xs="6"
                  sm="4"
                  md="4"
                >
                  <v-card 
                    class="font-italic text-center"
                    @click="activa('overlay2')"
                    max-height="200"
                    max-width="130"
                  >
                          <v-img
                            src="/tienda.png"
                            aspect-ratio="1"
                            max-height="200"
                            max-width="130"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                         <strong class="text-center ">En Tienda</strong>
                      <v-overlay
                            :absolute="absolute"
                            :value="overlay2"
                          >
                      </v-overlay>
                  </v-card>
                </v-col>


                <v-col 
                v-if="pagoyape.foto"
                class="pa-2"
                  cols="6"
                  xs="6"
                  sm="4"
                  md="4"
                >
    
                  <v-card                    
                    max-height="200"
                    max-width="130"
                    class="font-italic text-center"
                   @click="activa('overlay3'),fotoyape=pagoyape.foto"
                  >
                          <v-img
                          max-height="200"
                          max-width="130"
                            :src="pagoyape.foto"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <strong class="text-center">Yape</strong>
                      <v-overlay
                            :absolute="absolute"
                            :value="overlay3"
                          >
                      </v-overlay>
                  </v-card>
                </v-col>

                <v-col 
                v-if="whatsappbd.pagoWhatsappactivo"
                class="pa-2"
                  cols="6"
                  xs="6"
                  sm="4"
                  md="4"
                >
                  <v-card                    
                    max-height="200"
                    max-width="130"
                    class="font-italic text-center"
                   @click="activa('overlay4')"
                  >
                          <v-img
                          max-height="200"
                          max-width="130"
                          src="/what.png"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <strong class="text-center">Whatsapp</strong>
                      <v-overlay
                            :absolute="absolute"
                            :value="overlay4"
                          >
                      </v-overlay>
                  </v-card>
                </v-col>

                <v-col 
                v-if="otros.pagodepositoCuenta"
                class="pa-2"
                  cols="6"
                  xs="6"
                  sm="4"
                  md="4"
                >
                  <v-card                    
                    max-height="200"
                    max-width="130"
                    class="font-italic text-center"
                   @click="activa('overlay5')"
                  >
                          <v-img
                          max-height="200"
                          max-width="130"
                          src="/cajero.png"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <strong class="text-center">Deposito</strong>
                      <v-overlay
                            :absolute="absolute"
                            :value="overlay5"
                          >
                      </v-overlay>
                  </v-card>
                </v-col>


              </v-row>


                  <v-dialog
      v-model="dialog"
      max-width="390"
      >
    <v-system-bar window dark>
        <v-icon @click="dialog=!dialog">mdi-close</v-icon>
      </v-system-bar>
      <v-card 
        min-width="300"
        class="text-center">
                <p class="title text-center">
                <strong> Modo de pago</strong> 
                </p>
                <p class="red--text title">
                    {{metodoPago}}
                </p>

                <li v-if="otros.pagodepositoCuenta && metodoPago=='Deposito en cuenta'">
                <p 
                v-for="banc in bancos" :key="banc"
                > 
                    {{banc.banco}} : {{banc.cuenta}}
                </p>
                </li>

                <v-img                
                v-if="metodoPago=='Pago con Yape'"
                  :src="fotoyape"
                  aspect-ratio="1"
                  class="grey lighten-2 mx-auto "
                    max-height="250"
                    max-width="250"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <v-divider></v-divider>
              <p class="body-2 text-center">
                GRACIAS POR TU COMPRA NOS PONDREMOS EN CONTACTO LO ANTES POSIBLE 
              </p>
                 <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
      <router-link to="/" > 
      <v-btn :v-if="disabled=false" color="green" @click="e6 = 1,ventafinal()">Finalizar</v-btn>
      </router-link>
        </v-card-actions>
      </v-card>
    </v-dialog>

 </v-container>
 
</template>
<script>
import { db } from '../db'
import store from '@/store/index'

  export default {
      name: 'pasarelaPago',

        firebase: {
          tokefirebase:db.database().ref("token"),
          contador:db.database().ref("contadores"),
          pagoyape:db.database().ref("pagos").child("yape"),
          bancos:db.database().ref("pagos").child("bancos"),
          whatsappbd: db.database().ref("pagos").child("whatsapp"),
          otros: db.database().ref("pagos").child("otros"),
        },

    data () {
      return {
        disabled:false,
        fotoyape:'',
        pagoyape:{},
        bancos:1,
        whatsappbd:'',
        otros:'',
        tokefirebase:'',
        dialog:false,
        boton1: false,
        overlay1: false,
        overlay2: false,
        overlay3: false,
        overlay4: false,
        overlay5: false,
        absolute: true,
        metodoPago: '',
        contador:'',
        fecha:'',
        numeracionpedido:''
      }
    },
    methods:{
      activa(n){
        if(n=="overlay1"){
        this.overlay1= true,
        this.overlay2= false,
        this.overlay3= false,
        this.overlay4= false,
        this.overlay5= false,
        this.metodoPago = "Efectivo"
        }
        if(n=="overlay2"){
        this.overlay1= false,
        this.overlay2= true,
        this.overlay3= false,
        this.overlay4= false,
        this.overlay5= false,
        this.metodoPago = "Pago en tienda"
        }
        if(n=="overlay3"){
        this.overlay1= false,
        this.overlay2= false,
        this.overlay3= true,
        this.overlay4= false,
        this.overlay5= false,
        this.metodoPago = "Pago con Yape"
        }
        if(n=="overlay4"){
        this.overlay1= false,
        this.overlay2= false,
        this.overlay3= false,
        this.overlay4= true,
        this.overlay5= false,
        this.metodoPago = "Coordinar en WhatsApp"
        }
        if(n=="overlay5"){
        this.overlay1= false,
        this.overlay2= false,
        this.overlay3= false,
        this.overlay4= false,
        this.overlay5= true,
        this.metodoPago = "Deposito en cuenta"
        }
        this.dialog=true
      },

          ventafinal(){
              if(this.metodoPago=="Coordinar en WhatsApp"){
                window.open("https://api.whatsapp.com/send?phone=+51"+
                this.whatsappbd.pagoWhatsapp+"&text=Hola te saluda *"
                +store.state.cliente[0].nombreCompleto +
                "* he comprado " + store.state.totalproducto + " producto(s) "+
                "por un monto de *S/."+store.state.totalventa+
                "* Mi pedido es el numero *" + this.traernumeracionparaordenar() + 
                "* Quiero coordinar el pago con ustedes"
                ,
                "width=300, height=200")
              }
              var d  = (new Date()).toString()
              var numeracion = this.traernumerodePedido()
              var ordeninverso = this.traernumeracionparaordenar()
              db.database().ref("detallepedidos").child(numeracion).set(store.state.producto);
              db.database().ref("cabecera").child(numeracion).set({
               cliente: store.state.cliente[0].dni,
               totalacobrar: store.state.totalventa,
               totalproductos: store.state.totalproducto,
               modopago: this.metodoPago,
               direccion:store.state.direc[0].direccion,
               referencia:store.state.direc[0].referencia,
               fechapedido: d,
               ordenpedido: numeracion,
               estado:'#FF0000',
               inverso:ordeninverso,
              });
              
              this.enviarmensaje("Tienes Pedido de " + store.state.totalproducto + " productos",
              "Celular Cliente: " + store.state.cliente[0].celular + " - Apresurate en Atender!!" )
              store.commit('eliminarcarrito')
              this.contadores(numeracion,ordeninverso)
          },

        contadores(ordendepedido,ordeninverso){
            var a = parseInt(ordendepedido, 10) +1;
            db.database().ref("contadores").child('ordenpedido').set(a);
            var b = parseInt(ordeninverso, 10) -1;
            db.database().ref("contadores").child('pedidoinverso').set(b);
        },
     
        traernumerodePedido(){
           return this.contador.ordenpedido;
        },
        traernumeracionparaordenar(){
           return this.contador.pedidoinverso;
        },

          enviarmensaje(Titulo,Cuerpo){
                    console.log("enviando a ", this.tokefirebase.token)
                    //Clave de servidor es la key
                    var key = 'AAAA72W8HrU:APA91bGh0yhMT49lcTlXrPXv8dc9SsEdnQNXszh6oDu0U01uTJ0xggxcaw9S6Zn-dSXGzr-Q6pK5j6NwWdYK9T7p7IbpXUYkdBNSSbWTDkdX2X64hlSv9zGuAVW-IKLJloXisHo3t65D';
                    var to = this.tokefirebase.token ;
                    var notification = {
                    'title': Titulo,
                    'body':  Cuerpo,
                    'icon': 'pedidos.png',
                    'click_action': 'https://closet310-dfd89.web.app/detallepedido/'+ this.traernumerodePedido()
                    };

                    fetch('https://fcm.googleapis.com/fcm/send', {
                    'method': 'POST',
                    'headers': {
                        'Authorization': 'key=' + key,
                        'Content-Type': 'application/json'
                    },
                    'body': JSON.stringify({
                        'notification': notification,
                        'to': to
                    })
                    }).then(function(response) {
                    console.log("enviado",response);
                    }).catch(function(error) {
                    console.error("error",error);
                    })
                    this.loader = 'loading3'
        }
      }
  }
</script>